// Vendors
import * as PIXI from 'pixi.js'
// State Mashine
import { BlockStateMashine } from 'shared/state/block';

export class Block extends PIXI.Sprite {
    public moveToY: number;
    public color: string;
    public type: number;
    public row: number;
    public col: number;
    public mapNum: number;
    public shift: number;
    public stateMachine: BlockStateMashine;
    public isProductStart?: boolean; 
    public isProduct?: boolean;
    public isDelete: boolean;
    public isNew?: boolean;
    public isHidden: boolean;
    public isLast?: boolean;
    public id: string;
    public originScale: {x: number, y: number} = {x: null, y: null};

    constructor(texture: PIXI.Texture) {
        super(texture)
        this.zIndex = 1000000000;
        this.pivot.set(0.5)
    }
}